import axios from "axios";

// External API - uses different base URL (VITE_API_SWIMMERS_DIARY)
export async function getSwimmersDiary(phone: string, name: string, user_id: string) {
  const url = import.meta.env.VITE_API_SWIMMERS_DIARY;
  if (!url) {
    throw new Error("VITE_API_SWIMMERS_DIARY is not configured");
  }

  const response = await axios.get(url, {
    params: { phone, name, user_id },
    headers: {
      "Content-Type": "application/json",
      "apikey": import.meta.env.VITE_API_KEY,
    },
  });
  return response.data;
}
